export enum StorageKeys {
	Token = 'dashboard_auth_token',
}
